var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 432 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.753 516.083L27.8839 424.358L215.583 676.941L243.782 638.991V502.355L215.753 516.083Z",
    fill: "#708299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.583 0L0 386.827H431.171L215.583 0Z",
    fill: "#708299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M431.17 387.4L215.582 0V387.4H431.17Z",
    fill: "#68788E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.363 214.845H192.672V257.154H150.363V214.845Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.583 281.778L214.736 281.375L0.0205078 387.147H0.211599L214.927 492.919L215.774 492.516L243.781 478.809V295.588L215.583 281.778Z",
    fill: "#3C3C47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.363 134.818H192.672V177.127H150.363V134.818Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.753 516.082L215.582 676.94L403.415 424.188L215.753 516.082Z",
    fill: "#68788E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M430.767 387.147L215.582 281.778L214.735 281.375L214.926 492.919L215.773 492.516L430.958 387.147H430.767Z",
    fill: "#31313B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.e99a248b0c2a0bc0dd5d86764fa4b664.svg";
export { ForwardRef as ReactComponent };